import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

// Providers-Services
import { ApiRestService } from '../services/shared/api-rest.service';
import { NotifyService } from './shared/notify.service';

// import tablas
import { table } from '../components/shared/tables';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(
    private http: HttpClient,
    private _apiRestService: ApiRestService,
    public _notifyService: NotifyService) { }

  // Consulta usuario por padre
  getUser(prnt) {
    // return this.http.get(this._apiRestService.APIURL.serv6 + `/{"tble":"${table.user}","objc":{"prnt":"${prnt}"}}`)
    return this.http
      .get(
        this._apiRestService.APIURL.serv6 +
        `/{"tble":"${table.user}","type":"${table.type.metaExtn}","objc":{"prnt":"${prnt}"}}`
      )
      .pipe(
        map((res: Response) => {
          return res;
        })
      );
  }

  // Consulta todos los usuarios
  getUsers() {
    return this.http
      .get(
        this._apiRestService.APIURL.serv6 +
        `/{"tble":"${table.user}","type":"${table.type.metaExtn}"}`
      )
      .pipe(
        map((res: Response) => {
          let dataUser = { data: res };
          return dataUser;
        })
      );
  }

  // Consulta todos los roles de usuarios
  getRole() {
    return this.http
      .get(this._apiRestService.APIURL.serv6 + `/{"tble":"${table.role}"}`)
      .pipe(
        map((res: Response) => {
          return res;
        })
      );
  }

  // Guardar nuevo user
  createUser(user) {
    // console.log(`/{"tble":"${table.user}","objc":{"user":"${user.user}","tble_role":"${user.tble_role}","unidad":"${user.unidad}","nombre":"${user.nombre}","cargo":"${user.cargo}", "division":"${user.division}"}}`)
    return this.http
      .get(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.user}","objc":{"user":"${user.user}","tble_role":"${user.tble_role}","unidad":"${user.unidad}","nombre":"${user.nombre}","cargo":"${user.cargo}", "division":"${user.division}"}}`
      )
      .pipe(
        map((res: Response) => {
          return res;
        })
      );
  }


  // Valida si el usuario existe (atributo user)
  validUser(user) {
    return this.http
      .get(
        this._apiRestService.APIURL.serv4 +
        `/{"tble":"${table.user}","objc":{"user":"${user.user}"}}`
      )
      .pipe(
        map((res: Response) => {
          return res;
        })
      );
  }

  updateUser(prnt, user) {
    return this.http
      .get(
        this._apiRestService.APIURL.serv8 +
        `/{"tble":"${table.user}","prnt":"${prnt}","objc":${JSON.stringify(user)}}`
      )
      .pipe(
        map((res: Response) => {
          return res;
        })
      );
  }

  // Borrar user completo
  deleteUser(prnt) {
    return this.http
      .get(this._apiRestService.APIURL.serv9 + `/{"tble":"${table.user}","prnt":"${prnt}"}`)
      .pipe(
        map((res: Response) => {
          return res;
        })
      );
  }

  // Borrar atributos de usuario
  deleteUserAtrb(prnt, user) {
    return this.http
      .get(
        this._apiRestService.APIURL.serv9 +
        `/{"tble":"${table.user}","prnt":"${prnt}","objc":${JSON.stringify(user)}}`
      )
      .pipe(
        map((res: Response) => {
          return res;
        })
      );
  }

  // Comparar la data actual del usuario con la actualizada
  compareJSON(obj1, obj2) {
    let ret: any = {};
    for (let i in obj2) {
      if (!obj1.hasOwnProperty(i) || JSON.stringify(obj2[i]) !== JSON.stringify(obj1[i])) {
        ret[i] = obj2[i];
      }
    }
    return ret;
  }

  // Comparar la data del nuevo objero actulizar para determinat que debe borrar
  compareJSONBorrar(obj1, obj2) {
    let ret: any = {};
    for (let i in obj2) {
      if (obj1.hasOwnProperty(i)) {
        ret[i] = obj2[i];
      }
    }
    return ret;
  }

  // Cargar Dptos-Unidades según División enviada
  cargarUnidadesDvsion(division, divisiones) {
    return divisiones.filter(function (obj) {
      return Object.keys(obj).some(function (key) {
        return obj[key].includes(division);
      })
    });
  }

}
